import { render, staticRenderFns } from "./add-station-label.vue?vue&type=template&id=194f0aa8&"
import script from "./add-station-label.vue?vue&type=script&lang=js&"
export * from "./add-station-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports